<template>
  <PreLoader v-if="loading" />
  <LayoutVue />
</template>

<script>

import LayoutVue from "@/layout/Layout.vue";
import PreLoader from "@/components/PreLoader.vue";

export default {
  name: 'App',
  components: {
    PreLoader,
    LayoutVue
  },
  data(){
    return {
      loading: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000)
  }
}
</script>

<style>

</style>
